/**
 * Shared authenticated HTTP setup for axios.
 * Ensures every request carries the current JWT even if defaults were not set yet
 * (e.g. dashboard effects racing right after Google login).
 */
import axios from 'axios';

let interceptorInstalled = false;

export function installAuthInterceptor() {
  if (interceptorInstalled) return;
  interceptorInstalled = true;
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization && !config.headers.authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });
}

/** Persist token and mirror it onto axios defaults (password + Google login paths). */
export function applyAuthToken(token) {
  if (token) {
    localStorage.setItem('token', token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common.Authorization;
  }
}

installAuthInterceptor();
